// extracted by mini-css-extract-plugin
module.exports = {"text":"InformaRibbon_text__8pxvG","verticalBorder":"InformaRibbon_verticalBorder__NdBdd","navigation":"InformaRibbon_navigation__99WPE"};